import React, { useCallback, useState } from 'react';

import { motion } from 'framer-motion';

import FormHeader from 'components/FormHeader/FormHeader';

interface IOfferFormLayoutProps {
  title: string;
  isFormValid: boolean;
  onSave: () => void;
  onClose: () => void;
  previewContent?: React.ReactNode;
  extraContent?: React.ReactNode;
  mainButtonText?: string;
  showPreviewToggle?: boolean;
  children: React.ReactNode;
}

export const OfferFormLayout: React.FC<IOfferFormLayoutProps> = ({
  title,
  isFormValid,
  onSave,
  onClose,
  previewContent,
  extraContent,
  mainButtonText = 'Save',
  showPreviewToggle = true,
  children
}): React.ReactElement => {
  const [showPreview, setShowPreview] = useState<boolean>(true);

  const handlePreviewToggle = useCallback((): void => {
    setShowPreview((prev) => !prev);
  }, []);

  const showPreviewPanel = showPreview && !!previewContent;

  return (
    <React.Fragment>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
        className="bg-white fixed h-screen w-full top-0 left-0 z-[1000] overflow-hidden"
      >
        <FormHeader
          closeFormOnSubmit={false}
          onCloseForm={onClose}
          onMainButtonClick={onSave}
          title={title}
          isFormValid={isFormValid}
          mainButtonText={mainButtonText}
          secondaryButtonText={showPreviewToggle && previewContent ? (showPreview ? 'Hide Preview' : 'Show Preview') : undefined}
          onSecondaryButtonClick={showPreviewToggle && previewContent ? handlePreviewToggle : undefined}
        />
        <div className="flex h-[calc(100vh-73px)]">
          <div
            className={`flex justify-center overflow-y-auto px-3 ${showPreviewPanel ? 'w-1/2' : 'w-full'}`}
          >
            {children}
          </div>
          {showPreviewPanel && previewContent}
        </div>
      </motion.div>
      {extraContent}
    </React.Fragment>
  );
};
